import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const ViewPurchaseOrder = () => {
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path");
  const poId = searchParams.get("poId");

  useEffect(() => {
    // Update document title
    document.title = "Purchase Order - figabl";
  }, []);

  if (!path || !poId) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <p className="text-muted-foreground">Missing file parameters</p>
      </div>
    );
  }

  const fileUrl = `/api/serve-po-file?path=${encodeURIComponent(path)}&poId=${encodeURIComponent(poId)}`;

  return (
    <div className="w-full h-screen">
      <iframe
        src={fileUrl}
        className="w-full h-full border-0"
        title="Purchase Order Document"
      />
    </div>
  );
};

export default ViewPurchaseOrder;
